import React from 'react';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import CalculatorInput, { CalculatorInputProps } from './CalculatorInput';
import CalculatorResult from './CalculatorResult';

export interface CalculatorProps {
  inputs: CalculatorInputProps[];
  result: {
    upperLabel?: string;
    lowerLabel?: string;
    value: string;
  };
}

const Calculator = ({ inputs, result }: CalculatorProps): JSX.Element => {
  return (
    <Grid>
      <Stack direction='column'>
        <Stack
          padding='spacing-7xl'
          gap='spacing-4xl'
          background='bg-primary'
          direction='column'
          paddingSm='spacing-4xl'
        >
          {inputs.map((input) => (
            <Grid key={input.label}>
              <CalculatorInput {...input} />
            </Grid>
          ))}
        </Stack>
        <CalculatorResult {...result} />
      </Stack>
    </Grid>
  );
};

export default Calculator;
